import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Checkbox,
} from 'antd';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import DepartmentActions from '@Actions/departmentActions';
import H3FormInput from '@Uilib/h3FormInput';
import './style.scss';
import TenantCheckboxGroup from '../../../../Common/TenantCheckboxGroup';

/**
 *
 */
class DepartmentForm extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      allTenantsSelected: true,
      isAdmin: false,
    };
  }

  /**
   *
   */
  componentDidMount() {
    const { selectedDepartment, tenants } = this.props;
    if (window.location.href.includes('/admin')) {
      this.setState({ isAdmin: true });
    } else {
      this.setState({ isAdmin: false });
    }
    if (selectedDepartment) {
      const selectedTenants = [];
      for (let i = 0; i < selectedDepartment?.tenant_departments?.length; i++) {
        selectedTenants.push(selectedDepartment?.tenant_departments?.[i]?.tenant_id);
      }
      this.setState({
        departmentName: window.location.href.includes('/admin') ? selectedDepartment?.department_name : selectedDepartment?.alias_name,
        selectedTenants: selectedDepartment?.tenant_departments?.map((tenant) => tenant?.tenant_id),
        allTenantsSelected: tenants?.data?.length === selectedDepartment?.tenant_departments?.length,
      });
    }
  }

  /**
   *
   * @param {*} props
   * @param {*} state
   * @return
   */
  static getDerivedStateFromProps(props, state) {
    if (props.tenants && !state.selectedTenants && state.isAdmin && !props.selectedDepartment) {
      const selectedTenants = [];
      for (let i = 0; i < props?.tenants?.data?.length; i++) {
        selectedTenants.push(props?.tenants?.data?.[i]?.tenant_id);
      }
      return {
        ...state,
        selectedTenants,
      };
    }

    return state;
  }

  /**
   *
   */
  handleFormSubmit() {
    const {
      createDepartment, updateDepartment, user, callback, tenants, selectedDepartment,
    } = this.props;
    const { departmentName, selectedTenants, isAdmin } = this.state;
    this.setState({ formSubmitted: true });
    if (departmentName) {
      if (isAdmin) {
        if (selectedDepartment) {
          const tenantDepartment = [];
          for (let i = 0; i < tenants?.data?.length; i++) {
            tenantDepartment.push({
              tenant_id: tenants?.data?.[i]?.tenant_id,
              alias_name: departmentName,
              is_active: !!selectedTenants.includes(tenants?.data?.[i]?.tenant_id),
            });
          }
          const payload = {
            org_id: user?.tenant_info?.org_id,
            department_name: departmentName,
            tenant_departments: tenantDepartment,
            department_id: selectedDepartment?.department_id,
          };
          updateDepartment(payload, () => {
            callback();
          });
        } else {
          const tenantDepartment = [];
          for (let i = 0; i < tenants?.data?.length; i++) {
            if (selectedTenants.includes(tenants?.data?.[i]?.tenant_id)) {
              tenantDepartment.push({
                tenant_id: tenants?.data?.[i]?.tenant_id,
                alias_name: departmentName,
                is_active: !!selectedTenants.includes(tenants?.data?.[i]?.tenant_id),
              });
            }
          }

          const payload = {
            org_id: user?.tenant_info?.org_id,
            department_name: departmentName,
            tenant_departments: tenantDepartment,
          };
          createDepartment(payload, () => {
            callback();
          });
        }
      } else if (selectedDepartment) {
        const payload = {
          org_id: user?.tenant_info?.org_id,
          department_name: selectedDepartment?.department_name,
          is_active: true,
          tenant_id: user?.tenant_info?.tenant_id,
          alias_name: departmentName,
          department_id: selectedDepartment?.department_id,
        };
        updateDepartment(payload, () => {
          callback();
        });
      } else {
        const payload = {
          org_id: user?.tenant_info?.org_id,
          department_name: departmentName,
          is_active: true,
          tenant_id: user?.tenant_info?.tenant_id,
          alias_name: departmentName,
        };
        createDepartment(payload, () => {
          callback();
        });
      }
    }
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      createDepartmentLoading, updateDepartmentLoading, tenants, selectedDepartment, disableTenantCheckboxes,
    } = this.props;
    const {
      formSubmitted, departmentName, allTenantsSelected, selectedTenants, showSelectedTenants, isAdmin,
    } = this.state;
    return (
      <Fragment>
        <div className="form-department__heading">
          <div className="form-department__heading-input">
            <div className="ant-row">
              <div className="ant-col-md-24">
                <H3FormInput
                  name="department name"
                  type="text"
                  containerClassName="orgInputContainer"
                  labelClassName="orgFormLabel"
                  inputClassName="gst__input-add-department orgFormInput"
                  placeholder=""
                  onChange={(event) => this.setState({ departmentName: event.target.value })}
                  value={departmentName}
                  label="Department Name"
                  required
                  disabled={createDepartmentLoading || updateDepartmentLoading}
                  showError={formSubmitted && !(departmentName)}
                  maxlength="50"
                />
              </div>
            </div>
          </div>
          <div className="ant-col-md-24">
            {isAdmin && (
              <div className="add-department__tenant-list-wrapper">
                <div className="add-department__tenant-list-title">
                  <Checkbox
                    onChange={() => {
                      if (!allTenantsSelected) {
                        const defaultSelectedTenants = [];
                        for (let i = 0; i < tenants?.data?.length; i++) {
                          defaultSelectedTenants.push(tenants?.data?.[i]?.tenant_id);
                        }
                        this.setState({ allTenantsSelected: !allTenantsSelected, selectedTenants: defaultSelectedTenants });
                      } else {
                        this.setState({ allTenantsSelected: !allTenantsSelected, selectedTenants: [] });
                      }
                    }}
                    disabled={createDepartmentLoading || updateDepartmentLoading || disableTenantCheckboxes}
                    checked={allTenantsSelected}
                  />
                  <div className="add-department__tenant-list-title-text">
                    All Business Units
                    <span
                      onClick={() => this.setState({ showSelectedTenants: !showSelectedTenants })}
                    >
                      {showSelectedTenants ? "Show less" : "Show all"}
                    </span>
                  </div>
                </div>
                {(showSelectedTenants) && (
                  <TenantCheckboxGroup
                    tenants={tenants}
                    onChange={(value) => {
                      this.setState({ selectedTenants: value, allTenantsSelected: value?.length === tenants?.data?.length });
                    }}
                    disabled={createDepartmentLoading || updateDepartmentLoading || disableTenantCheckboxes}
                    selectedValues={selectedTenants}
                  />
                )}
              </div>
            )}

          </div>
        </div>

        {/* {Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
          Helpers.permissionTypes.CREATE, user) && ( */}
        <div className="form-department__footer">
          <H3Button
            text={selectedDepartment ? 'Update Department' : 'Create Department'}
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            disabled={createDepartmentLoading || updateDepartmentLoading}
            isLoading={createDepartmentLoading || updateDepartmentLoading}
            customClass="form-department__footer-submit"
            onClick={() => this.handleFormSubmit()}
          />
        </div>

      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, DepartmentReducers, TenantReducers,
}) => ({
  user: UserReducers.user,
  createDepartmentLoading: DepartmentReducers.updateDepartmentLoading,
  updateDepartmentLoading: DepartmentReducers.createDepartmentLoading,
  tenants: TenantReducers.tenants,

});

const mapDispatchToProps = (dispatch) => ({
  createDepartment: (payload, callback) => dispatch(DepartmentActions.createDepartment(payload, callback)),
  updateDepartment: (payload, callback) => dispatch(DepartmentActions.updateDepartment(payload, callback)),

});

DepartmentForm.propTypes = {
  createDepartment: PropTypes.func,
  createDepartmentLoading: PropTypes.bool,
  updateDepartmentLoading: PropTypes.bool,
  updateDepartment: PropTypes.func,
  callback: PropTypes.func,
  user: PropTypes.any,
  tenants: PropTypes.any,
  selectedDepartment: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DepartmentForm));
